import axios from './custom-axios';

export const containersLoader = async ({ params }) => {
  return axios.get(`/manage.json`);
};

export const containerLoader = async ({ params }) => {
  return axios.get(`/manage/containers/${params.container_id}.json`);
};

export const formSubmissionsLoader = async ({ params }) => {
  return axios.get(`/manage/forms/${params.form_id}.json`);
};

export const formEditLoader = async ({ params }) => {
  return axios.get(`/manage/forms/${params.form_id}/edit.json`);
};

export const fieldsetLoader = async ({ params }) => {
  return axios.get(`/manage/fieldsets/${params.fieldset_id}.json`);
};

export const fieldLoader = async ({ params }) => {
  return axios.get(`/manage/fields/${params.field_id}.json`);
};

export const mailersLoader = async ({ params }) => {
  return axios.get(`/manage/forms/${params.form_id}/mailers.json`);
};

export const mailerLoader = async ({ params }) => {
  return axios.get(`/manage/mailers/${params.mailer_id}.json`);
};

export const submissionLoader = async ({ params }) => {
  return axios.get(`/manage/submissions/${params.submission_id}.json`);
};

export const permissionsLoader = async ({ params }) => {
  return axios.get(`/manage/permissions.json`);
};
